<template>
    <div :style="{width: `${size}px`, height: `${size}px`}" class="flex-shrink-0 relative">
        <UserInfoPopover :userProps="user" :activePopover="activePopover" class="w-full h-full">
            <div class="relative w-full h-full">
                    <router-link v-if="router" :to="{name: 'profile', params: {user_name: user.user_name, tab: tab}}" :target="target" class="block w-full h-full" :aria-label="user?.name || user?.user_name">
                        <img :src="user.avatar" :alt="user?.name || user?.user_name" class="rounded-full w-full h-full object-cover" :width="size" :height="size" decoding="async" loading="lazy" />
                        <div v-if="border" class="absolute inset-0 rounded-full border border-media-inner dark:border-media-inner-dark"></div>
                    </router-link>
                    <div v-else class="w-full h-full">
                        <img :src="user.avatar" :alt="user?.name || user?.user_name" class="rounded-full w-full h-full object-cover" :width="size" :height="size" decoding="async" loading="lazy" />
                        <div v-if="border" class="absolute inset-0 rounded-full border border-media-inner dark:border-media-inner-dark"></div>
                    </div>
            </div>
        </UserInfoPopover>
   </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
const UserInfoPopover = defineAsyncComponent(() => import('@/components/user/UserInfoPopover.vue'));

export default {
    components: { UserInfoPopover },
    props: {
        user: {
            type: Object,
            default: null
        },
        size: {
            type: Number,
            default: 40
        },
        target: {
            type: String,
            default: ''
        },
        activePopover: {
            type: Boolean,
            default: true
        },
        border: {
            type: Boolean,
            default: true
        },
        router: {
            type: Boolean,
            default: true
        },
        tab: {
            type: String,
            default: ''
        }
    }
}
</script>
